import { Badge, BadgeProps, Text } from '@mantine/core';

interface Props extends Omit<BadgeProps, 'children'> {
	text: string;
	textColor?: string;
	color?: string;
	'data-testid'?: string;
}

export const StatusBadge = ({ text, color, textColor, ...badgeProps }: Props) => {
	return (
		<Badge variant="outline" size="sm" color={color} {...badgeProps}>
			<Text
				fz="sm"
				fw={400}
				c={textColor}
				truncate
				lineClamp={1}
				style={{ textWrap: 'nowrap' }}
			>
				{text}
			</Text>
		</Badge>
	);
};
